import type { FaireProductEntity } from "../../entity_types/product";

export const p_zrj26hg9j2: FaireProductEntity = {
  token: "p_zrj26hg9j2",
  type: "product",
  name: "Elegant Double-Layer Rhinestone Stud Earrings DP25D820",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl: "https://cdn.faire.com/fastly/137ac1cdadac0c6ef6f103839b11d0856dc96837c072a528fcfff0fa07b9f93a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a26354116a1ae94d855009919011012f0174b351d8637a5c790cf78a3da266f9.jpeg",
    "https://cdn.faire.com/fastly/740ab673f8bdd179318e0bd391bf7871f92b1aea6355fa50d258864c3a2e4528.jpeg"
  ],
  priceDollars: 2.06,
  description: "Feature:\n * Double-Layer\n * Shell\n * Rhinestone\n * Geometric\n * Vintage, Simple \n * Elegant \n * Daily Fitting\n * Gift\n\n Weigh:\n * 10g\n\n Material:\n * Alloy\n\n Package:\n * Package include 1 pair of earrings.\n\n Note: See picture labels (size and weight are hand-measured there will be a small error, specific in kind shall prevail, please note the size before purchase)",
  tags: [],
  msrpDollars: 4.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:23.621Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
